import * as Types from './workstationActionTypes.js'

const initialState = {
    workstations: [],
    zones: [],
    machineParameters: [],
    activeWorkstations: [],
    selectedWorkstation: 0,
    workstationNotificationsDrawerOpen: false,
    noSelectedWorkstation: false,
};

export default function workstation(state = initialState, action) {
    switch (action.type) {
        case Types.SET_WORKSTATIONS:
            if (state.workstations !== action.workstations) {
                return Object.assign({}, state, { workstations: action.workstations });
            }
            return state;
        
        case Types.SET_MACHINEPARAMETERS:
            if (state.machineParameters !== action.parameters) {
                return Object.assign({}, state, { machineParameters: action.parameters });
            }
            return state;
        case Types.SET_ACTIVEWORKSTATIONS:
            if (state.activeWorkstations !== action.activeWorkstations) {
                return Object.assign({}, state, { activeWorkstations: action.activeWorkstations });
            }
            return state;
        // case Types.SET_SELECTEDWORKSTATION:
        //     if (state.selectedWorkstation !== action.selectedWorkstation) {
        //         return Object.assign({}, state, { selectedWorkstation: action.selectedWorkstation });
        //     }
        //     return state;
      
        case Types.SET_NOSELECTEDWORKSTATION:
            if (state.noSelectedWorkstation !== action.noSelectedWorkstation) {
                return Object.assign({}, state, { noSelectedWorkstation: action.noSelectedWorkstation });
            }
            return state;
        case Types.SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN:
            if (state.workstationNotificationsDrawerOpen !== action.workstationNotificationsDrawerOpen) {
                return Object.assign({}, state, { workstationNotificationsDrawerOpen: action.workstationNotificationsDrawerOpen });
            }
            return state;          
        default:
            return state;
    }
}